module.exports = __webpack_public_path__ + "img/29.14069d78.jpg";